const parseLocalDate = (dateString: string) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateString);
    if (match) {
        const year = Number(match[1]);
        const month = Number(match[2]) - 1;
        const day = Number(match[3]);
        return new Date(year, month, day);
    }
    return new Date(dateString);
};

const AppHelper = {
    formatDate(dateString?: string) {
        if (!dateString) return '';
        const date = parseLocalDate(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const days = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
        const dayOfWeek = days[date.getDay()];

        return {
            day,
            month,
            year,
            dayOfWeek,
            fullDate: `${day}.${month}.${year}`
        };
    },
    // Форматирование времени
    formatTime(timeString?: string) {
        if (!timeString) return '';
        return timeString.substring(0, 5); // Берем только часы:минуты
    },
    formatPrice(price?: number) {
        if (price === 0 || !price) return 'Бесплатно';

        // Добавляем пробелы между тысячами
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    formatDateToMask(isoDate: string) {
        if (!isoDate) return '';

        const date = parseLocalDate(isoDate);
        if (isNaN(date.getTime())) return '';

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    },
    formatShortDate(dateString?: string) {
        if (!dateString) return '';
        const date = parseLocalDate(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const months = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
        const month = months[date.getMonth()];
        return `${day} ${month}`;
    },
    formatDateTimeRuLong(dateString?: string, timeString?: string) {
        if (!dateString) return '';

        const date = parseLocalDate(dateString);
        if (isNaN(date.getTime())) return '';

        const day = date.getDate().toString();
        const months = [
            'января',
            'февраля',
            'марта',
            'апреля',
            'мая',
            'июня',
            'июля',
            'августа',
            'сентября',
            'октября',
            'ноября',
            'декабря',
        ];
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        const days = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
        const dayOfWeek = days[date.getDay()];

        const time = AppHelper.formatTime(timeString);
        const timePart = time ? `, ${time}` : '';

        return `${day} ${month} ${year} (${dayOfWeek})${timePart}`;
    },
}
export default AppHelper
